import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.income;

const getIncome = createSelector(getData, income => values(income));

export default getIncome;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getIncome.js